var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { createContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { breakpoints } from 'Styles/breakpoints';
export var BreakpointContext = createContext(undefined);
/**
 * Custom hook for adding breakpoint information to a component
 * @returns {BreakpointContext} Breakpoint state
 */
export var useBreakpoint = function () {
    var context = React.useContext(BreakpointContext);
    if (context === undefined) {
        throw new Error('useBreakpoint must be used within a BreakpointProvider');
    }
    return context.currentBreakpoints;
};
/**
 * `BreakpointProvider` is used to provide adaptive breakpoint context to a component tree.
 */
var BreakpointProvider = function (_a) {
    var children = _a.children;
    var mediaMatches = {};
    var sizes = [
        'small',
        'medium',
        'large',
        'xlarge',
        'largest'
    ];
    if (typeof window !== 'undefined' && window.matchMedia) {
        mediaMatches = sizes.reduce(function (acc, value) {
            var _a;
            return (__assign(__assign({}, acc), (_a = {}, _a[value] = window.matchMedia("(min-width: ".concat(breakpoints[value], "px)")), _a)));
        }, {});
    }
    var matching = Object.keys(mediaMatches).reduce(function (acc, value) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[value] = mediaMatches[value].matches, _a)));
    }, {});
    var _b = useState(matching), currentBreakpoints = _b[0], setBreakpoints = _b[1];
    useEffect(function () {
        var handleChange = function () {
            return setBreakpoints(Object.keys(mediaMatches).reduce(function (acc, value) {
                var _a;
                return (__assign(__assign({}, acc), (_a = {}, _a[value] = mediaMatches[value].matches, _a)));
            }, {}));
        };
        if (typeof window !== 'undefined' &&
            typeof window.matchMedia !== 'undefined') {
            Object.keys(mediaMatches).forEach(function (media) {
                return mediaMatches[media].addListener(handleChange);
            });
            return function () {
                Object.keys(mediaMatches).forEach(function (media) {
                    return mediaMatches[media].removeListener(handleChange);
                });
            };
        }
    }, []);
    return (React.createElement(BreakpointContext.Provider, { value: { currentBreakpoints: currentBreakpoints } }, children));
};
BreakpointProvider.propTypes = {
    /**
     * Content to render inside Breakpoint provider tree
     */
    children: PropTypes.node.isRequired
};
export default BreakpointProvider;
